import { render, staticRenderFns } from "./SelectUserBlock.vue?vue&type=template&id=43baaa23&scoped=true"
import script from "./SelectUserBlock.vue?vue&type=script&lang=js"
export * from "./SelectUserBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43baaa23",
  null
  
)

export default component.exports